/* src/app/private/components/leads/column-info/column-info.component.scss */
.dashboard-container {
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}
.dashboard-title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
  font-weight: bold;
}
.data-table {
  border: 1px solid var(--secondry-dark-gray);
  border-radius: 8px;
  overflow: hidden;
}
.data-row {
  display: flex;
  gap: 20px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--secondry-dark-gray);
}
.data-row:last-child {
  border-bottom: none;
}
.data-key {
  font-weight: bold;
  flex: 1;
}
.data-value {
  flex: 6;
  flex-wrap: wrap;
  gap: 5px 10px;
}
.data-value li {
  line-height: 1.6;
}
/*# sourceMappingURL=column-info.component.css.map */
